// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","isModal":"Loader_isModal__KVO9T"};